<template>
  <a class="link-cell" @click="clickAction">
    {{ text }}
  </a>
</template>

<script>
export default {
  name: "LinkCell",
  props: {
    clickAction: {
      type: Function,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.link-cell {
  @apply text-red;
}
</style>
